export enum DirTypeEnum {
    NA = 'N_A',
    Dropped = 'DROPPED',
    LiquidDamage = 'LIQUID_DAMAGE'
}
